import { render } from "./AddCommentComponent.vue?vue&type=template&id=9fd176a6&scoped=true&ts=true"
import script from "./AddCommentComponent.vue?vue&type=script&lang=ts"
export * from "./AddCommentComponent.vue?vue&type=script&lang=ts"

import "./AddCommentComponent.vue?vue&type=style&index=0&id=9fd176a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd176a6"]])

export default __exports__